import { updateRemote } from '../atomic';
import ENTITIES from '..';

export function editClient(store, data) {
  updateRemote(store, ENTITIES.CLIENT, data);
}
